import React from 'react'
import styled from 'styled-components'
import {TrendingUp, TrendingDown} from 'lucide-react'

interface MetricCardProps {
  title: string
  value: string
  icon?: React.ReactNode
  change?: {
    value: string
    type: 'increase' | 'decrease' | 'neutral'
  }
  className?: string
}

const CardContainer = styled.div`
  background: var(--bg-card);
  border-radius: var(--radius-md);
  padding: var(--space-6);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-regular);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
`

const CardHeader = styled.div`
  display: flex;
  justify-content: between;
  align-items: center;
`

const CardTitle = styled.h3`
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  flex: 1;
`

const CardIcon = styled.div`
  color: #9ca3af;
  flex-shrink: 0;
`

const CardValue = styled.div`
  color: #111827;
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
`

const CardChange = styled.div<{$type: 'increase' | 'decrease' | 'neutral'}>`
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => {
    switch (props.$type) {
      case 'increase':
        return '#059669'
      case 'decrease':
        return '#dc2626'
      default:
        return 'var(--text-secondary)'
    }
  }};
`

export const MetricCard: React.FC<MetricCardProps> = ({title, value, icon, change, className}) => {
  const renderChangeIcon = () => {
    if (!change) return null

    switch (change.type) {
      case 'increase':
        return <TrendingUp size={16} />
      case 'decrease':
        return <TrendingDown size={16} />
      default:
        return null
    }
  }

  return (
    <CardContainer className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {icon && <CardIcon>{icon}</CardIcon>}
      </CardHeader>
      <CardValue>{value}</CardValue>
      {change && (
        <CardChange $type={change.type}>
          {renderChangeIcon()}
          {change.value}
        </CardChange>
      )}
    </CardContainer>
  )
}

export default MetricCard
